import { render, staticRenderFns } from "./FavoriteCarsPopup.vue?vue&type=template&id=fa4c2296&scoped=true"
import script from "./FavoriteCarsPopup.vue?vue&type=script&lang=ts"
export * from "./FavoriteCarsPopup.vue?vue&type=script&lang=ts"
import style0 from "./FavoriteCarsPopup.vue?vue&type=style&index=0&id=fa4c2296&prod&lang=scss&scoped=true"
import style1 from "./FavoriteCarsPopup.vue?vue&type=style&index=1&id=fa4c2296&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4c2296",
  null
  
)

export default component.exports